import React from 'react';
import { Supportbutton } from "../../../../src/components/elements/SupportButton";


import "./styles.scss";

const MainLayout = (props) => {
    return (
        <div className="container-fluid">
            <div className="main-container">
            <Supportbutton />

                {props.children}
            </div>
        </div>
    );
};

export default MainLayout;
